export default __webpack_public_path__ + "static/media/linkedin.6892b3ae.png";